/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewEmailForm
 */
export interface NewEmailForm {
    /**
     * 
     * @type {string}
     * @memberof NewEmailForm
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof NewEmailForm
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof NewEmailForm
     */
    authenticationToken: string;
    /**
     * 
     * @type {string}
     * @memberof NewEmailForm
     */
    newEmailAuthenticationToken?: string;
}

/**
 * Check if a given object implements the NewEmailForm interface.
 */
export function instanceOfNewEmailForm(value: object): value is NewEmailForm {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('authenticationToken' in value) || value['authenticationToken'] === undefined) return false;
    return true;
}

export function NewEmailFormFromJSON(json: any): NewEmailForm {
    return NewEmailFormFromJSONTyped(json, false);
}

export function NewEmailFormFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewEmailForm {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'password': json['password'],
        'authenticationToken': json['authenticationToken'],
        'newEmailAuthenticationToken': json['newEmailAuthenticationToken'] == null ? undefined : json['newEmailAuthenticationToken'],
    };
}

export function NewEmailFormToJSON(value?: NewEmailForm | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'password': value['password'],
        'authenticationToken': value['authenticationToken'],
        'newEmailAuthenticationToken': value['newEmailAuthenticationToken'],
    };
}

